import ApiService from "../apiService";
import { get, patch, post, destroy } from "../apiService";
const _ = require("lodash");
const model = "accounts";

export default class AccountService extends ApiService {
  findAll(searchTerm) {
    return get(`/${model}`, {
      params: {
        "filter[search]": searchTerm
      }
    });
  }

  find(id) {
    return get(`/${model}/${id}`, {
      params: {
        include: "location"
      }
    });
  }

  activeAccount() {
    return get(`/account/current`, {
      params: {
        include: "location"
      }
    });
  }

  save(item) {
    delete item.attributes["acceptedTerms"];
    delete item.attributes["fileUrl"];
    delete item["attachments"];
    delete item["relationships"];
    delete item["location"];
    delete item["accountUser"];
    return this.baseSave(model, item);
  }

  archive(item) {
    return this.baseArchive(model, item);
  }
}



// WEBPACK FOOTER //
// ./src/services/accountService/index.js